import { motion, AnimatePresence } from 'framer-motion'

interface Props {
  open: boolean
  onUpdate: () => void
  onDismiss: () => void
}

export function UpdateBanner({ open, onUpdate, onDismiss }: Props) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 80, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 350, damping: 35 }}
          style={{
            position: 'fixed', zIndex: 20,
            left: 16, right: 16, bottom: 'calc(16px + env(safe-area-inset-bottom))',
            background: 'var(--ml-surface)', borderRadius: 'var(--ml-radius-input)',
            padding: '14px 16px',
            display: 'flex', alignItems: 'center', gap: 12,
          }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 15, fontWeight: 600 }}>A new version is available</div>
            <div style={{ fontSize: 13, color: 'var(--ml-text-secondary)', marginTop: 2 }}>
              Update to get the latest changes.
            </div>
          </div>

          <button
            onClick={onDismiss}
            style={{
              border: 'none', background: 'none', padding: '8px 4px',
              color: 'var(--ml-text-secondary)', fontSize: 15,
              cursor: 'pointer',
            }}
          >
            Later
          </button>

          <button
            onClick={onUpdate}
            style={{
              border: 'none', borderRadius: 'var(--ml-radius-button)', padding: '8px 16px',
              background: 'var(--ml-primary-bg)', color: 'var(--ml-primary-fg)', fontSize: 15, fontWeight: 600,
                cursor: 'pointer',
            }}
          >
            Update
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
